<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="map-marked-alt"
    :items="filteredMiniMarketTeams"
    :loading="loading"
    @search="onSearch"
    @focus="onSearch"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { useMiniMarketTeamActions } from "~/components/_refactored/conductor/mini-market-teams/teams/useMiniMarketTeamActions";

export default {
  props: {
    value: {
      type: [Array, Object],
      default: () => null,
    },
  },
  setup() {
    const { getMiniMarketTeamsForAutocomplete } = useMiniMarketTeamActions();
    const filteredMiniMarketTeams = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getMiniMarketTeamsForAutocomplete({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredMiniMarketTeams.value = items;
      loading.value = false;
    };

    return {
      filteredMiniMarketTeams,
      onSearch,
      loading,
    };
  },
};
</script>
